import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const itemAliasDeleteAtom = createMutationAtomFactory(
  'settings.itemAliasDelete',
  (params: { id: string }) => ({
    tradeItemAliasDelete: {
      __args: {
        id: params.id,
      },
      success: true,
    },
  }),
);
